'use strict';

/**
 * @returns {object} : minX, maxX, minY, maxY, minZ, maxZ, width, height, depth
 */

module.exports = function () {
  return function getBoundary() {
    var minX = Number.POSITIVE_INFINITY;
    var maxX = Number.NEGATIVE_INFINITY;
    var minY = Number.POSITIVE_INFINITY;
    var maxY = Number.NEGATIVE_INFINITY;
    var minZ = Number.POSITIVE_INFINITY;
    var maxZ = Number.NEGATIVE_INFINITY;

    for (var i = 0; i < this.getAllAtoms(); i++) {
      var x = this.getAtomX(i);
      var y = this.getAtomY(i);
      var z = this.getAtomZ(i);
      minX = Math.min(minX, x);
      maxX = Math.max(maxX, x);
      minY = Math.min(minY, y);
      maxY = Math.max(maxY, y);
      minZ = Math.min(minY, z);
      maxZ = Math.max(maxY, z);
    }

    return {
      minX,
      maxX,
      maxY,
      minY,
      maxZ,
      minZ,
      width: maxX - minX,
      height: maxY - minY,
      depth: maxZ - minZ
    };
  };
};